<template>
	<div class="patients layout__box">

		<!-- Table -->
		<table id="js-basic-table" class="basic-table">

			<!-- Row -->
			<tr class="basic-table__row basic-table__row_headers hr">
				<th class="basic-table__title">Фото</th>
				<th class="basic-table__title">Фамилия Имя Отчество</th>
				<th class="basic-table__title">Пол</th>
				<th class="basic-table__title">Дата рождения</th>
				<th class="basic-table__title">Телефон</th>
				<th class="basic-table__title">Последний визит</th>
			</tr>
			<!-- Row End -->

			<!-- Row -->
			<tr class="basic-table__row hr" v-for="client in clients" @click="showCard(client)">
				<td class="basic-table__cell">

					<div class="basic-table__inner">
						<div class="basic-table__label">Фото:</div>

						<div class="basic-table__field">
							<div class="basic-table__avatar-wrap">
								<user-avatar :data="client.user" :set-class="'basic-table__avatar'"></user-avatar>
							</div>
						</div>
					</div>

				</td>
				<td class="basic-table__cell patients__name">
					<div class="basic-table__inner">
						<div class="basic-table__label">Имя:</div>
						<div class="basic-table__field">
							{{client.user.last_name}} {{client.user.first_name}} {{client.user.middle_name}}
						</div>
					</div>
				</td>

				<td class="basic-table__cell">

					<div class="basic-table__inner">
						<div class="basic-table__label">Пол:</div>
						<div class="basic-table__field">{{(client.user.sex == 'male') ? 'Муж' : 'Жен'}}</div>
					</div>

				</td>

				<td class="basic-table__cell">

					<div class="basic-table__inner">
						<div class="basic-table__label">Дата рождения:</div>
						<div class="basic-table__field">{{[client.user.birthday, 'X'] | moment('DD.MM.YY')}}</div>
					</div>

				</td>

				<td class="basic-table__cell">

					<div class="basic-table__inner">
						<div class="basic-table__label">Телефон:</div>
						<div class="basic-table__field">+{{client.user.phone}}</div>
					</div>

				</td>

				<td class="basic-table__cell">

					<div class="basic-table__inner">
						<div class="basic-table__label">Последний визит:</div>
						<div class="basic-table__field" v-if="client.last_agenda_time">
							{{client.last_agenda_time | data('DD.MM.YYYY')}}
						</div>
						<div class="basic-table__field" v-else> - </div>
					</div>

				</td>

			</tr>
			<!-- Row End -->

		</table>
		<!-- Table End -->
	</div>
	<!-- Layout Box End -->
</template>

<script>
	export default {
		name: 'Patients',
		computed: {
			clinicId() {
				return this.$route.params.clinic
			}
		},
		mounted() {
			this.$event.connect('userModalResponse', () => {
				this.getPatients(this.clinicId)
			})

			this.getPatients(this.clinicId)

		},
		beforeDestroy() {
			this.$event.disconnect('userModalResponse')
		},
		data() {
			return {
				clients: []
			}
		},
		methods: {
			getPatients(id) {
				this.$store.dispatch('worker/patients', {
					per_page: 50,
					current_page: 1,
					clinic_id: id
				}).then(response => {
					this.clients = response.data
				})
			},
			createNewUser() {
				this.$event.send('openClientModal', {}, 'patient')
			},
			editPatient(patient) {
				this.$event.send('openClientModal', patient, 'patient')
			},
			showCard(client) {
				this.$router.push({
					name: 'Card',
					params: {
						id: client.user._id
					}
				})
			}


		}
	}
</script>



// WEBPACK FOOTER //
// Patients.vue?79959e1c